import '../css/Content.css';
import React, { useState, useRef, useEffect  } from 'react';
import { Carousel } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import QuizActivity2 from './QuizActivity2';

export const Lesson2 = () => {
  // const [mostraTexto, setMostraTexto] = useState({});

  // const toggleTexto = (id) => {
  //   setMostraTexto((prev) => ({
  //     ...prev,
  //     [id]: !prev[id],
  //   }));
  // };


  //SA

 const [videoSrc, setVideoSrc] = useState('./video/module2/SA_introducao.mp4');
  const [showAlternatives, setShowAlternatives] = useState(false);
  const [divInfoBorder, setDivInfoBorder] = useState('8px solid #2CADA8');
  const [imgSrc, setImgSrc] = useState('./src/images/modulo1/x8.png');
  const [showDivInfo, setShowDivInfo] = useState(false);
  const [shouldPlay, setShouldPlay] = useState(false);
  const videoRef = useRef(null);

  // Handle video source change and auto-play after alternative selection
  useEffect(() => {
    if (videoRef.current && videoSrc) {
      videoRef.current.load(); // Ensure the new source is loaded
      if (shouldPlay) {
        videoRef.current.play().catch((error) => {
          console.error('Erro ao reproduzir vídeo:', error);
        });
      }
    }
  }, [videoSrc, shouldPlay]);

  const mostrarAlternativasC1 = () => {
    if (videoSrc.includes('SA_introducao.mp4')) {
      setShowAlternatives(true);
      setShouldPlay(false); // Prevent auto-play when showing alternatives
    } else {
      setShowAlternatives(false);
      setVideoSrc('./video/module2/SA_introducao.mp4');
      if (videoRef.current) {
        videoRef.current.pause();
      }
      setShouldPlay(false); // Ensure no auto-play when resetting to intro video
    }
  };

  const respostasC1 = (id) => {
    // setShowDivInfo(true); // Show divInfo when an alternative is selected
    if (id === 'div1-resposta-m2p2') {
      setVideoSrc('./video/module2/SA_certa.mp4');
      setShowAlternatives(false);
      setDivInfoBorder('8px solid #2CADA8');
      setImgSrc('./img/icons/x8.png');
      setShouldPlay(true); // Trigger auto-play after source change
    } else if (id === 'div2-resposta-m2p2' || id === 'div3-resposta-m2p2') {
      setVideoSrc('./video/module2/SA_errada.mp4');
      setShowAlternatives(false);
      setDivInfoBorder('8px solid #e3c867');
      setImgSrc('./img/icons/x10.png');
      setShouldPlay(true); // Trigger auto-play after source change
    } else if (id === 'fecharDiv-q1-m2p2') {
      setShowDivInfo(false);
      setShouldPlay(false); // No auto-play when closing divInfo
    }
  };





  

  const [grupoAtivo, setGrupoAtivo] = useState('');

  // Simula o setTimeout da função original
  useEffect(() => {
    const timeout = setTimeout(() => {
      // avancarConteudo(getCookie("avancar"));
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);


  // const handleClick = (grupo) => {
  //   setGrupoAtivo(grupo);
  // };

  const [openIndex, setOpenIndex] = useState(null);
  const [openIndex2, setOpenIndex2] = useState(null);
  const [openIndex3, setOpenIndex3] = useState(null);
  const [openIndex4, setOpenIndex4] = useState(null);
  const [openIndex5, setOpenIndex5] = useState(null);


  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const toggleAccordion2 = (index) => {
    setOpenIndex2(openIndex2 === index ? null : index);
  };
  const toggleAccordion3 = (index) => {
    setOpenIndex3(openIndex3 === index ? null : index);
  };
  const toggleAccordion4 = (index) => {
    setOpenIndex4(openIndex4 === index ? null : index);
  };
  const toggleAccordion5 = (index) => {
    setOpenIndex5(openIndex5 === index ? null : index);
  };



  const containerRef = useRef(null);
    const imageRefs = {
      img1: useRef(null),
      img2: useRef(null),
      img3: useRef(null),
      img4: useRef(null)
    };
  
    const applyZoom = (event) => {
      const zoomContainer = containerRef.current;

      if (!zoomContainer) {
      console.warn("zoomContainer está null");
      return;
    }
      const rect = zoomContainer.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
  
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
  
      Object.values(imageRefs).forEach((ref) => {
        if (ref.current) {
          ref.current.style.transformOrigin = `${xPercent}% ${yPercent}%`;
          ref.current.style.transform = 'scale(2)';
        }
      });
    };
  
    const resetZoom = () => {
      Object.values(imageRefs).forEach((ref) => {
        if (ref.current) {
          ref.current.style.transform = 'scale(1)';
          ref.current.style.transformOrigin = 'center center';
        }
      });
    };

  const containerRef2 = useRef(null);
  const imageRefs2 = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null)
  };

  const applyZoom2 = (event) => {
    const zoomContainer2 = containerRef2.current;
    
    if (!zoomContainer2) {
      console.warn("zoomContainer2 está null");
      return;
    }

    const rect2 = zoomContainer2.getBoundingClientRect();
    const x2 = event.clientX - rect2.left;
    const y2 = event.clientY - rect2.top;

    const xPercent2 = (x2 / rect2.width) * 100;
    const yPercent2 = (y2 / rect2.height) * 100;

    Object.values(imageRefs2).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transformOrigin = `${xPercent2}% ${yPercent2}%`;
        ref.current.style.transform = 'scale(2)';
      }
    });
  };

  const resetZoom2 = () => {
    Object.values(imageRefs2).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transform = 'scale(1)';
        ref.current.style.transformOrigin = 'center center';
      }
    });
  };

  const containerRef3 = useRef(null);
  const imageRefs3 = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null)
  };

  const applyZoom3 = (event) => {
    const zoomContainer3 = containerRef3.current;
    
    if (!zoomContainer3) {
      console.warn("zoomContainer3 está null");
      return;
    }

    const rect3 = zoomContainer3.getBoundingClientRect();
    const x2 = event.clientX - rect3.left;
    const y2 = event.clientY - rect3.top;

    const xPercent3 = (x2 / rect3.width) * 100;
    const yPercent3 = (y2 / rect3.height) * 100;

    Object.values(imageRefs3).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transformOrigin = `${xPercent3}% ${yPercent3}%`;
        ref.current.style.transform = 'scale(2)';
      }
    });
  };

  const resetZoom3 = () => {
    Object.values(imageRefs3).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transform = 'scale(1)';
        ref.current.style.transformOrigin = 'center center';
      }
    });
  };


  const containerRef4 = useRef(null);
  const imageRefs4 = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null)
  };

  const applyZoom4 = (event) => {
    const zoomContainer4 = containerRef4.current;
    const rect4 = zoomContainer4.getBoundingClientRect();
    const x2 = event.clientX - rect4.left;
    const y2 = event.clientY - rect4.top;

    const xPercent4 = (x2 / rect4.width) * 100;
    const yPercent4 = (y2 / rect4.height) * 100;

    Object.values(imageRefs4).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transformOrigin = `${xPercent4}% ${yPercent4}%`;
        ref.current.style.transform = 'scale(2)';
      }
    });
  };

  const resetZoom4 = () => {
    Object.values(imageRefs4).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transform = 'scale(1)';
        ref.current.style.transformOrigin = 'center center';
      }
    });
  };

      // ************ MODAL 1 *********************
    
        const [showModal, setShowModal] = useState(false);
        const [modalContent, setModalContent] = useState({ title: "", description: "" });
       
    
        // Função para abrir modal e definir conteúdo
        const openModal = (e) => {
          const target = e.currentTarget;
          console.log(target)
          setModalContent({
            title: target.dataset.title,
            description: target.dataset.description,
            image: target.dataset.image,
          });
          setShowModal(true);
    
        }




  return (
    <>      
      <section className="article" id="article_1" style={{background: 'linear-gradient(161deg, #05A3C7 25%, #001755 100%) fixed',
        backgroundAttachment: 'fixed'}}> {/* className: gradient-background */}
       

       {/* ---------------------------- TELA 1 --------------------------------------- */}
        <article id='l2id1'
         style={{
            display: 'flex',
            minHeight: '100vh',
            background: '#131326',
            position: 'relative'
          }}>



          <div className="container">
            <div
              className="row d-flex align-items-center justify-content-center fontS-18"
              style={{ paddinBottom: "80px", marginTop: '40px' }}
            >

              <div className="col-md-6">
                  <h4 style={{marginBottom: '40px', color: '#ffffff'}}>Olá! Bem-vindos ao <span style={{color: '#00A8D0'}}>Módulo II do Curso de Projeto Hidrossanitário – BIM. </span> </h4>

                  <img src="./img/module1/bg_modulo1_pag1.jpg" style={{width: '100%'}} alt="" />
              </div>


              <div className="col-md-6" style={{height: '85vh', display: 'flex', alignItems: 'center'}}>
                <div style={{ width: '90%', marginTop: '30px', padding: '5% 5% 10% 5% ', borderRadius: '12px', color: '#ffffff', background: 'linear-gradient(161deg, #05A3C7 25%, #000000ff 80%)'}}>
                  <p>
                    Nesta etapa, vamos avançar na modelagem das instalações hidrossanitárias, aplicando na prática os recursos do Revit em ambiente BIM.
                  </p>
                  <p>
                    Durante a modelagem, cada tubo, válvula e conexão é um objeto inteligente, com informações de material, diâmetro e fabricante. Isso torna o modelo digital mais <strong>completo e confiável</strong>, apoiando todas as fases da obra, do planejamento à manutenção.
                  </p>
                  <p>
                    Com essa abordagem, é possível <strong>testar soluções, detectar incompatibilidades e colaborar entre disciplinas</strong>, ganhando eficiência e reduzindo retrabalhos.
                    E o primeiro passo dessa jornada prática é inserir e vincular arquivos no Revit, garantindo que o sistema hidrossanitário esteja alinhado com o restante do projeto.
                  </p>               
                  <p>
                    <strong>Vamos começar?</strong> 
                  </p>              
                </div>
              </div>
              

            </div>
          </div>

        </article>    

        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}
        
        <article id='l2id2'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module2/topico2-m2.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>                    

       

        {/* ---------------------------- TELA 2 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: "#EDE6D8",
          }}>
     
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">             
              <div className="col-md-12 fontS-18">
                <p>
                  No Autodesk Revit, é possível inserir arquivos externos, como desenhos de referência ou modelos de outras disciplinas, para coordenar os diferentes aspectos do projeto. Esse recurso é essencial para garantir que as instalações hidrossanitárias estejam bem integradas ao restante da edificação.
                </p>              
              </div>
            </div>
            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px' }}>
              <img src="./img/module2/modulo2_pag2.png" style={{ width: '70%' }} alt="A imagem explica o significado da sigla BIM: Building Information Modeling (Modelagem da Informação da Construção)." />
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Na prática, podem ser utilizados arquivos em formato RVT (outros modelos do Revit) ou DWG (desenhos CAD). Essa integração permite que o modelo hidrossanitário seja desenvolvido em conformidade com o arquitetônico e o estrutural, evitando inconsistências e retrabalhos. 
                </p>              
              </div>
            </div>
          </div>
        </article>


        {/* ---------------------------- TELA 3 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  O vídeo a seguir mostra como realizar a vinculação de arquivos nos formatos RVT e DWG:
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/76TIseuZLMc?si=e9u0tX6al8aDyI7H" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 4 --------------------------------------- */}
        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#ffffff'
          // display: 'none' 
          }}>
          <div className="container">         
              <div className="row">
                <div className="col-md-12 fontS-18">
                  <p>
                    Depois de observar o procedimento na prática, vale destacar alguns cuidados que tornam o uso de arquivos vinculados no Revit mais seguro e eficiente.
                  </p>                                  
                </div>
              </div>

            <div className="row" style={{ backgroundColor: '#489FC4', display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 60, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-2">
                <img src="./img/module2/modulo2_exclama.svg" alt="" />
              </div>
              <div className="col-md-10 fontS-18" style={{ display: 'flex', alignItems: 'center', color: '#ffffff', fontWeight: 500 }}>
                <p>
                  Ao utilizar arquivos no formato RVT, é importante definir previamente com a equipe qual versão do software será utilizada, já que o Revit não salva em versões anteriores. Outro cuidado essencial é usar a função <strong>Auditar</strong> ao abrir o arquivo que será vinculado. Esse processo realiza uma verificação automática, corrigindo possíveis falhas e garantindo maior estabilidade do modelo.   
                </p>                
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Então, para vincular um modelo arquitetônico, ou de qualquer outra disciplina, basta acessar a guia <strong>inserir e selecionar</strong> a opção <strong>Vínculo do Revit</strong>. Ao fazer isso, será aberta uma janela onde você escolhe o arquivo que deseja inserir.  
                </p>                   
                <p>
                  Na sequência, é preciso definir o <strong>tipo de posicionamento</strong>. Essa escolha é muito importante, pois determina como o modelo vinculado será alinhado ao projeto em que você está trabalhando.   
                </p>                   
              </div>
            </div>
          
          </div>
        </article>
                                


        {/* ---------------------------- TELA 5 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">          
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                Veja as duas opções disponíveis:
              </p>
            </div>

            {[1, 2].map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Auto</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Manual</strong>}                        
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Insere o arquivo de forma automática. Essa opção deve ser usada com cautela, pois exige que as configurações de georreferenciamento já estejam definidas corretamente. Se houver inconsistências, o modelo pode ser posicionado de forma incorreta.
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O modelo aparece “grudado” ao mouse e só é posicionado após você clicar no local desejado. Essa opção oferece mais liberdade, mas pode resultar em desalinhamentos se não houver um ponto de referência claro.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                    </div>
                  )}
                </div>
              );
            })}

            <div className="row">          
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px', marginTop: '40px' }}>
                Em projetos colaborativos, a escolha mais comum é <strong>Auto – Origem interna para origem interna</strong>, pois respeita as coordenadas internas já configuradas, garantindo que todos os modelos permaneçam consistentes entre si.
              </p>
            </div>

          </div>
        </article>


        {/* ---------------------------- TELA 6 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  O vídeo a seguir mostra, passo a passo, como realizar esse procedimento no Revit:
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/Ds-YvUO_V2E?si=5ZlI0HmYw1v5rAvZ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

              <div className="row" style={{ marginTop: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Ao aplicar esse recurso, o vínculo entre os modelos fica estável e corretamente posicionado. Isso facilita a coordenação, a detecção de interferências e a visualização integrada da edificação.
                </p>
              </div>
            </div>
        
          </div>
        </article>

        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}
        
        <article id='l2id3'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module2/topico3-m2.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>            


        {/* ---------------------------- TELA 7 --------------------------------------- */}
        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Assim, avançamos para a compreensão dos componentes do modelo, que são os elementos inseridos no projeto, como torneiras, chuveiros, vasos sanitários ou caixas d’água. No BIM, esses componentes se organizam em famílias, responsáveis por estruturar e classificar cada item do sistema. 
                </p>      
                {/* <p>
                  Clique no botões a seguir e veja como esses elementos aparecem na interface do Revit.
                </p>               */}
              </div>
            </div>

            <div
              className={`modal fade ${showModal ? "show d-block" : ""}`}
              tabIndex="-1"
              style={{ background: "rgba(0,0,0,0.5)", width: '100%', height: '100%' }}
            >
              <div className="modal-xl modal-dialog-centered" style={{height: '100%', display: 'flex', background: 'rgba(25, 53, 78, 0.58)', backdropFilter: 'blur(10px)', paddingRight: '15px', alignItems: 'baseline'}}>
                <div className="modal-content" style={{width: '90%', height: '70%', marginLeft: 'auto', marginRight: 'auto', background: 'none'}}>
                  <div className="modal-header" style={{borderBottom: 'none'}}>
                    
                  </div>
                  <div className="modal-body">
                    <div className="row"  style={{justifyContent: 'center'}}>
                      <div className="col-md-6" style={{display: 'flex', justifyContent: 'center', padding: '0',}}>
                        <div className='row' style={{width: '100%', justifyContent: 'center', borderRadius: '12px 12px 0 0', backgroundColor: '#ffffff'}}>
                          <div className="col-md-2" >
                            {/* <p className='title-modal3' style={{color: 'ffffff', fontWeight: '500', fontSize: '70px', textAlign: 'center'}}>{modalContent.description}</p> */}
                          </div>
                          <div  className='col-md-8' >
                            {/* <p className='title-size' style={{color: 'ffffff', fontWeight: '500', fontSize: '32px', textAlign: 'center'}}>Rolamento de rolos cilíndricos</p> */}
                          </div>
                          <div  className='col-md-2' style={{textAlign: 'right'}}>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)} style={{color: '#ffffff', fontSize: '30px', fontWeight: '500', opacity: '1'}}></button>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div className="row"  style={{justifyContent: 'center'}}>
                      <div className="col-md-6" style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '0 0 12px 12px'}}>
                        <div ref={containerRef} onMouseMove={applyZoom} onMouseLeave={resetZoom} >
                          {modalContent.image && <img src={modalContent.image} ref={imageRefs.img1} alt="Zoom 1" id="zoom-image1" style={{Width: '100%', height: 'auto', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '0 0 12px 12px', backgroundColor: '#ffffff'}}/>}
                        </div>                      

                      </div>
                    </div>
                    
                    
                  </div>                 
                </div>
              </div>
            </div>


            <div
              className="row"
              style={{ marginTop: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <div className="col-md-4" style={{ marginBottom: "30px", cursor: 'pointer' }} 
              data-title="PROPRIEDADES" data-description={`1`} 
              data-image="./img/module2/modulo2_pag7.2.jpg" 
              onClick={openModal}>

                <img src="./img/module2/modulo2_pag7.1.jpg" style={{width: '100%', marginBottom: '-20px'}} alt="" />

                <div
                  className="row"
                  data-toggle="modal"
                  data-target=".bd-Mod2Part3-modal-xl"
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    backgroundColor: "#00A8D0",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    fontWeight: 500,
                    minHeight: "55px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    borderRadius: "5px",
                    position: 'relative',                    
                  }}
                
                >
                  <div className="col-md-12">
                    <p                      
                      style={{
                        color: "#ffffff",
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: 0,
                        paddingRight: 0,
                        cursor: "pointer",
                        textAlign: 'center'
                      }}
                    >
                      Clique aqui
                    </p>
                  </div>                 
                    <img
                      id="seta1-m2I2"
                      className="pulse-image"
                      src="./img/icon/seta_indica.svg"
                      alt=""
                      style={{ position: "absolute", height: "auto", maxWidth: "65px", bottom: "-18px" }}
                    />
                </div>
              </div>
            </div>

            {/* MODAL */}
            <div
              className="modal fade bd-Mod2Part3-modal-xl"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
              style={{ backgroundColor: "#19354e94", backdropFilter: "blur(10px)" }}
            >
              <div
                className="modal-dialog modal-xl"
                style={{
                  height: "90%",
                  maxWidth: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="modal-content" style={{ width: "95%", background: "none" }}>            

                  <div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* ---------------------------- TELA 8 --------------------------------------- */}
        
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Isso significa que cada componente inserido no modelo já carrega dados que podem ser ajustados conforme as necessidades do projeto, tornando o BIM muito mais inteligente e funcional.
                </p>
                <p style={{color: '#ffffff'}}>
                  Para que você entenda melhor esse conceito, <strong>assista ao vídeo a seguir</strong>:
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/plCvL2AoIGE?si=0xDeENpvD3wgz_m4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 9 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">          
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                Contudo, para organizar melhor o projeto, os componentes no Revit seguem uma hierarquia em quatro níveis: 
              </p>              
            </div>

            {[1, 2, 3, 4].map((item, index) => {
              const isOpen = openIndex2 === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion2(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Categoria</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Família</strong>}                        
                          {index === 2 && <strong>Tipo</strong>}                        
                          {index === 3 && <strong>Instância</strong>}                        
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              É o grupo mais amplo, como tubulações, louças ou conectores hidrossanitários. 
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Conjunto mais específicos dentro da categoria. Por exemplo, na categoria “Tubulações”, podemos ter a família “Tubos de PVC”. 
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              É a variação de uma família. Usando o exemplo do tubo, podemos ter “PVC de 50 mm” e “PVC de 100 mm”.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O objeto individual que você realmente coloca no projeto. Ou seja, aquele tubo de PVC de 100 mm que aparece em determinado trecho da instalação é uma instância do tipo selecionado.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                    </div>
                  )}
                </div>
              );
            })}

            <div className="row" style={{marginTop: '40px'}}>          
              <p className="fontS-18" style={{ color: "#ffffff"}}>
                Essa hierarquia garante organização, padronização e facilidade na geração de quantitativos. Além da forma, cada componente pode receber parâmetros e metadados, como material, diâmetro e fabricante, que dão inteligência ao modelo. Vamos aprofundar um pouco mais sobre esse tema?
              </p>
            </div>

          </div>
        </article>


        {/* ---------------------------- TELA 10 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#EDE6D8'       
        }}>


          <div className="container" style={{paddingBottom: '80px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#000000' }}>
                <p>
                  <strong>Associação de metadados e parâmetros a elementos e componentes</strong>
                </p>
                <p>
                  Ao inserir um tubo ou uma válvula no Revit, não se está apenas criando uma representação gráfica de uma peça, mas adicionando um elemento paramétrico capaz de armazenar informações técnicas relevantes. Esses dados, conhecidos como <strong>parâmetros e metadados</strong>, permitem que cada componente do projeto hidrossanitário carregue atributos fundamentais, como:
                </p>                             
              </div>
            </div>

              <div
                className="row"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                  marginBottom: "40px",
                }}
              >
               <div className="col-md-4" style={{ display: 'flex', marginBottom: '20px'}}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      especificações técnicas
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" style={{ display: 'flex', marginBottom: '20px'}}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      diâmetro nominal 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" style={{ display: 'flex'}}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      material
                      (PVC, cobre, ferro fundido)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" style={{ display: 'flex'}}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      fabricante
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" style={{ display: 'flex'}}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      custos
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" style={{ display: 'flex'}}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      datas de manutenção
                    </p>
                  </div>
                </div>
              </div>
            </div>  

          </div>
        </article>


        {/* ---------------------------- TELA 11 --------------------------------------- */}

        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Veja o exemplo: na figura a seguir, temos as propriedades de uma família de caixa d’água. Nela, aparecem parâmetros como descrição, endereço da web (URL), link do produto, fabricante e até observações detalhadas.
                </p>      
                {/* <p>
                  Clique no botões a seguir e veja como esses elementos aparecem na interface do Revit.
                </p>               */}
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className='col-md-8' ref={containerRef2} onMouseMove={applyZoom2} onMouseLeave={resetZoom2} style={{textAlign: 'center', padding: '0', overflow: 'hidden', display: 'flex', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: '0 0 12px 12px'}}>
                    {<img src="./img/module2/modulo2_pag11.jpg" ref={imageRefs2.img1} alt="Zoom 1" id="zoom-image1" style={{width: '75%', height: 'auto', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '0 0 12px 12px'}}/>}
                  </div>     
                </div>
            </div>


            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff', marginTop: '50px' }}>              
                <p>
                  O elemento inserido no modelo representa uma especificação clara e detalhada do material. Essa associação fornece informações valiosas para todas as fases do ciclo de vida da edificação, desde o projeto conceitual até a operação e manutenção e apoia a análise e a tomada de decisões técnicas.
                </p>                      
              </div>
            </div>



          </div>
        </article>      



        {/* ---------------------------- TELA 12 --------------------------------------- */}

        <article className="post avanco3-M2-t" style={{ 
          backgroundColor: "#EDE6D8", 
          display: 'flex', 
          alignItems: 'center'
          }}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">          
              <p className="fontS-18" style={{ color: "#000000", marginBottom: '60px' }}>
                <strong>Configuração e uso de elementos e famílias </strong>
              </p>
              <p className="fontS-18" style={{ color: "#000000", marginBottom: '60px' }}>
                No Revit, os elementos agrupados em famílias podem ser configurados para atender às necessidades do projeto. Isso inclui:
              </p>
            </div>

            {[1, 2, 3, 4, 5, 6, 7].map((item, index) => {
              const isOpen = openIndex3 === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion3(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Personalização de Parâmetros</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Seleção de Tipos de Elementos</strong>}                        
                          {index === 2 && <strong>Renderização e Visualização</strong>}                        
                          {index === 3 && <strong>Coordenação com Outros Elementos</strong>}                        
                          {index === 4 && <strong>Padronização e Consistência</strong>}                        
                          {index === 5 && <strong>Bibliotecas de Conteúdo</strong>}                        
                          {index === 6 && <strong>Documentação e Anotação</strong>}                        
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O Revit permite personalizar parâmetros de cada elemento, como dimensões, materiais, propriedades construtivas, dados de fabricação e informações do projeto, possibilitando a criação de componentes ajustados às necessidades específicas.
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              No Revit, componentes hidrossanitários como tubulações, conexões e válvulas possuem tipos pré-definidos que variam em diâmetro, material e características específicas. A seleção adequada desses tipos agiliza a modelagem e garante precisão no projeto hidráulico e sanitário.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O Revit oferece recursos avançados de renderização e visualização para elementos componentes. Isso permite que os projetistas criem representações visuais realistas dos elementos, com texturas de materiais, cores e iluminação. Essas representações ajudam a comunicar efetivamente o design aos clientes e partes interessadas.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O Revit oferece recursos de coordenação de elementos e visualização para elementos componentes. Isso permite que os projetistas criem representações visuais realistas dos elementos, com texturas de materiais, cores e iluminação. Essas representações ajudam a comunicar efetivamente o design aos clientes e partes interessadas.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 4 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              A configuração de elementos componentes permite a aplicação de padronização e a manutenção da consistência em todo o projeto. Isso garante que os elementos tenham tamanhos e materiais compatíveis e com o mesmo método, mantendo a integridade do projeto.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 5 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Normalmente os softwares BIM vêm com uma vasta biblioteca de famílias de elementos componentes, incluindo tubos e conexões. No entanto, os usuários também podem criar suas próprias famílias personalizadas para atender às suas bibliotecas de acordo com as necessidades do projeto.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 6 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              À medida que os elementos são modelados e configurados, é importante incluir informações adequadas para a documentação do projeto. Isso inclui rótulos, etiquetas, legendas e outras formas de anotação que descrevem as características e os parâmetros dos elementos.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                    </div>
                  )}
                </div>
              );
            })}           
          </div>
        </article>


        {/* ---------------------------- TELA 13 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Assista ao vídeo e veja como configurar os componentes do modelo:
                </p>              
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/L59ByeElt54?si=9JnuCJOwzDlkRea3" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Note que configurar elementos e famílias garante que o modelo hidrossanitário esteja de acordo com as especificações do projeto. 
                </p>              
                <p style={{color: '#ffffff'}}>
                  Porém, nem sempre as bibliotecas prontas atendem a todas as necessidades. É nesse ponto que entra a criação de famílias e objetos customizados, recurso essencial para adaptar o modelo às particularidades de cada obra.
                </p>              
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 14 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          // backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  <strong>Criação de famílias e objetos customizados</strong>
                </p>              
                <p style={{color: '#ffffff'}}>
                  Nas instalações hidrossanitárias, pode ser necessário criar dispositivos, conexões ou equipamentos especiais que não estão na biblioteca do Revit. Para isso, definimos sua geometria, parâmetros e informações próprias.
                </p>              
                <p style={{color: '#ffffff'}}>
                  Vamos ver a seguir como criar famílias de componentes no Revit:
                </p>              
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/BbzgoakaFwY?si=K0FeKHtpQneWZC8B" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>
                                


        {/* ---------------------------- TELA 15 --------------------------------------- */}

        
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">     
                        
                <p style={{color: '#ffffff'}}>
                  Essa flexibilidade é um dos pontos fortes do BIM: quando os elementos padrão não atendem, você pode modelar objetos customizados para representar com precisão a realidade do projeto.
                </p>              
                <p style={{color: '#ffffff'}}>
                  Veja como aplicar:
                </p>              
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/4s7RiPpd5fM?si=-C3KKDOR_-dcooUQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Você percebe como isso se torna especialmente importante em sistemas hidrossanitários, que frequentemente exigem soluções específicas?
                </p>                      
              </div>
            </div>
        
          </div>
        </article>
                      

        {/* ---------------------------- TELA 16 --------------------------------------- */}

        
        <article className="post comecoM2-t" style={{
          // backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  <strong>Pesquisa e inserção de elementos a partir de bibliotecas de componentes virtuais</strong>
                </p>              
                <p style={{color: '#ffffff'}}>
                  Grande parte do trabalho de modelagem é feita usando elementos já disponíveis em bibliotecas virtuais. O Revit oferece diversas famílias de componentes genéricos, e muitos fabricantes disponibilizam versões próprias em seus sites ou plugins.
                </p>              
                <p style={{color: '#ffffff'}}>
                  Para as instalações hidrossanitárias, isso inclui tubos, conexões, válvulas, registros, bombas e equipamentos. Basta pesquisar, baixar e inserir esses elementos no modelo. Confira no vídeo como fazer esse processo:
                </p>              
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/oN1PFaqtdBY?si=YwhON7lMb31_K_hN" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>


        {/* ---------------------------- TELA 17 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#ffffff'
          // display: 'none' 
          }}>
          <div className="container">  

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Essa prática é essencial porque permite trabalhar com componentes realistas e detalhados, economizando tempo e garantindo mais precisão no modelo. 
                </p>                                 
              </div>
            </div>       

            <div className="row" style={{ backgroundColor: '#489FC4', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 30, marginBottom: 60, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-2">
                <img src="./img/module2/modulo2_exclama.svg" alt="" />
              </div>
              <div className="col-md-10 fontS-18" style={{ marginTop: '2%', color: '#ffffff', fontWeight: 500 }}>
                <p>
                  <strong>Fique de olho!</strong> Nem sempre todos os objetos baixados vêm configurados com os parâmetros que você precisa. Ajuste materiais, dimensões e informações antes de usar no projeto.
                </p>                
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Com os elementos já configurados, o próximo passo é aprender a modificar os sistemas de tubulação, entendendo como conectar os componentes e estruturar redes completas. 
                </p>                                
              </div>
            </div>
          
          </div>
        </article>


        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}
        
        <article id='l2id4'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module2/topico4-m2.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>            


        {/* ---------------------------- TELA 18 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          display: 'flex',
          alignItems: 'center', 
          backgroundColor: '#131326' 
          }}>
          <div className="container" style={{ marginBottom: 60, marginTop: '2%' }}>
            <div className="row" style={{ marginBottom: 30 }}>
              
              <p style={{color: '#ffffff' }}>
                Um sistema hidrossanitário vai muito além dos tubos, como você já percebeu ao longo deste estudo. Ele é composto por diversas peças e equipamentos que, juntos, asseguram tanto o abastecimento de água quanto o escoamento adequado dos efluentes. 
              </p>
              <p style={{color: '#ffffff' }}>
                Esses componentes são variados: desde tubulações e conexões até válvulas, registros e reservatórios. Cada um tem uma função específica para que o sistema funcione corretamente.
              </p>
              <p style={{color: '#ffffff' }}>
                Para entender melhor como tudo isso se organiza, que tal olharmos juntos para dois pontos que fazem toda a diferença no projeto? Primeiro, os materiais e características dos componentes, que determinam como cada peça vai se comportar na instalação. Depois, os tubos, encaixes e conexões, que formam a base física do sistema. Vamos lá?
              </p>
            </div>
        
          </div>
        </article>
                               



        {/* ---------------------------- TELA 19 --------------------------------------- */}

        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  <strong>Materiais: Características e Tipos</strong>
                </p>                
                <p>
                  Observe a imagem a seguir: ela mostra a configuração de uma conexão no Revit, com o parâmetro de perda de carga, conforme estabelecido na NBR 5626:2020  . Esse é um bom exemplo de como cada componente pode trazer dados técnicos que impactam diretamente no desempenho do sistema.
                </p>                
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className='col-md-8' ref={containerRef3} onMouseMove={applyZoom3} onMouseLeave={resetZoom3} style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '0 0 12px 12px'}}>
                    {<img src="./img/module2/modulo2_pag19.jpg" ref={imageRefs3.img1} alt="Zoom 1" id="zoom-image1" style={{width: '100%', height: 'auto', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '0 0 12px 12px'}}/>}
                  </div>     
                </div>
            </div>

            <div className="row" style={{marginTop: '40px'}}>
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Em instalações hidrossanitárias, aspectos como taxa de fluxo, pressão máxima suportada e resistência ao calor precisam ser considerados. No Revit, essas características podem ser configuradas para que o modelo represente de forma confiável o comportamento real da rede.
                </p>                      
              </div>
            </div>



          </div>
        </article>      


        {/* ---------------------------- TELA 20 --------------------------------------- */}

       <article className="post avanco3-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: "#EDE6D8",
          }}>
     
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">              
              <div className="col-md-12 fontS-18">
                <p>
                  Além disso, a escolha do material como: PVC, cobre, ferro fundido, entre outros, influencia tanto na eficiência quanto na durabilidade do sistema. Associar esses materiais aos componentes no modelo permite prever custos, adequação normativa e desempenho ainda na fase de projeto.
                </p>              
              </div>
            </div>
            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px' }}>
              <img src="./img/module2/modulo2_pag20.jpg" style={{ width: '70%' }} alt="A imagem mostra um exemplo de uma instalação com tubo de esgoto em PVC." />
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  No Revit, é possível selecionar e atribuir esses tipos de materiais aos componentes. Isso não apenas afeta a aparência dos elementos no modelo, mas também suas propriedades físicas e de comportamento, como condutividade térmica, resistência à corrosão e durabilidade.  
                </p>              
              </div>
            </div>
          </div>
        </article>


        {/* ---------------------------- TELA 21 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '60px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  No vídeo a seguir, você verá como escolher o material certo e aplicá-lo corretamente no modelo:
                </p>                          
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/ILrO7sM6K2s?si=pikptM3Wi99awFKl" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

              <div className="row">
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  A escolha do material, como mostrado no vídeo, não se limita à aparência: ela estabelece propriedades físicas, interfere nos custos, assegura a conformidade com normas e determina a durabilidade do sistema.
                </p>                          
              </div>
            </div>

        
          </div>
        </article>

        {/* ---------------------------- TELA 22 --------------------------------------- */}
        
        <article className="post avanco5-M2-t" style={{ 
          // display: 'none', 
          backgroundColor: '#EDE6D8' 
          }}>
          <div className="container" style={{ marginBottom: 60, marginTop: '2%' }}>
            <div className="row" style={{ marginBottom: 30 }}>
              <p className='title-size' style={{ fontSize: 36, color: '#00A8D0', fontWeight: 500 }}>
                <strong>Tubos, encaixes e conexões</strong> 
              </p>
              <p style={{color: '#000000' }}>
                Esse cuidado com os materiais se conecta diretamente ao próximo ponto do projeto: os tubos, encaixes e conexões, que dão forma e continuidade ao sistema hidrossanitário no modelo BIM. 
              </p>
              <p style={{color: '#000000' }}>
                Pense nos tubos como as “veias” do sistema, responsáveis por transportar a água ou o esgoto. Para que essa rede funcione, entram em cena os encaixes e conexões, que permitem mudanças de direção, ramificações e ligações com equipamentos.
              </p>
              <p style={{color: '#000000' }}>
                Nos modelos BIM, é possível trabalhar com uma grande variedade de encaixes e conexões: cotovelos, joelhos, tês, adaptadores, flanges, entre outros.
              </p>
            </div>
        
          </div>
        </article>
                         

        {/* ---------------------------- TELA 23 --------------------------------------- */}
        <article
          className="post comecoM2-p3-1t"
          style={{ 
            backgroundColor: "#131326"  
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Nos modelos BIM, é possível configurar uma ampla variedade de encaixes e conexões, como cotovelos, joelhos, tês, adaptadores, flanges, dentre outros. Cada tipo de encaixe ou conexão pode ser personalizado com parâmetros que incluem tamanho, ângulo, tipo de conexão (roscada, soldada, flangeada, etc.) e informações relacionadas à fabricação, como número de peça do fabricante, como podemos observar na imagem a seguir.
                </p>      
                {/* <p>
                  Clique no botões a seguir e veja como esses elementos aparecem na interface do Revit.
                </p>               */}
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className='col-md-8' ref={containerRef4} onMouseMove={applyZoom4} onMouseLeave={resetZoom4} style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '0 0 12px 12px'}}>
                    {<img src="./img/module2/modulo2_pag23.jpg" ref={imageRefs4.img1} alt="Zoom 1" id="zoom-image1" style={{width: '100%', height: 'auto', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '0 0 12px 12px'}}/>}
                  </div>     
                </div>
            </div>


            <div className="row" style={{marginTop: '40px'}}>
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Cada um desses itens pode ser ajustado em parâmetros como tamanho, ângulo e tipo de conexão. Também é possível incluir informações do fabricante, como o código da peça.
                </p>
                <p>
                  Assim, o modelo não mostra apenas o desenho da conexão, mas representa com precisão como ela será usada na instalação.
                </p>                      
              </div>
            </div>



          </div>
        </article> 

        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}
        
        <article id='l2id5'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module2/topico5-m2.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>                 


        {/* ---------------------------- TELA 24 --------------------------------------- */}
        <article className="post comeco1-p2-t" style={{ 
          display: 'flex', 
          alignItems: 'center'
        // background: '#ffffff' 
        }}>
        <div className="container" style={{paddingBottom: '30px'}}>
          <div className="row" style={{ marginLeft: 0, marginTop: '10px', color: '#ffffff', display: 'block' }}>
            {/* <p className="fontS-18" style={{width: '100%'}}>
              <strong>Modelagem E Modificação De Sistemas De Tubulação</strong>
            </p> */}
            <p className="fontS-18" style={{width: '100%'}}>
              O Revit não foi criado especificamente para cálculos hidrossanitários, mas pode ajudar bastante nessa parte do projeto. Com ele, é possível definir diâmetros de tubulação, verificar pressões e até analisar perdas de carga.
            </p>
          </div>
          <div className="row fontS-18" style={{ marginTop: '40px', marginBottom: '30px' }}>
            <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  background: 'linear-gradient(to bottom, #e6e6e600 55%, #006191 0%)',
                  width: '100%',
                  height: '220px',
                  paddingTop: '2%',
                  borderRadius: '12px',
                  border: '2px solid #1c7fa0 '
                }}
              >
                <p className='width95'
                  style={{
                    backgroundColor: '#629fb9',
                    color: '#ffffff',
                    fontWeight: 400,
                    padding: '5%',
                    width: '95%',
                    height: '87%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  Para isso, é importante ajustar corretamente os critérios de projeto, usar bibliotecas bem configuradas, aplicar templates adequados e aproveitar o recurso das tabelas. 
                </p>
              </div>
            </div>
          </div> 

          <div className="row" style={{ marginLeft: 0, marginTop: '10px', color: '#ffffff', display: 'block' }}>
            <p className="fontS-18" style={{width: '100%'}}>
              Dessa forma, o software se torna um aliado na análise de desempenho do sistema,  sempre lembrando que os resultados devem ser revisados e confirmados pelo projetista responsável.
            </p>
          </div>   
        </div>
      </article>                  



        {/* ---------------------------- TELA 25 --------------------------------------- */}
                
        <article className="post avanco5-M2-t" style={{ 
          display: 'flex', 
          alignItems: 'center',
          backgroundColor: '#131326' 
          }}>
          <div className="container" style={{ marginBottom: 60, marginTop: '2%' }}>
            <div className="row" style={{ marginBottom: 30 }}>              
              <p style={{color: '#ffffff' }}>
                Você já sabe que um sistema hidrossanitário é formado por tubos, conexões, válvulas e equipamentos. Agora que essa base está clara, vamos avançar para a próxima etapa: modelar o sistema de tubulação no Revit, integrando todos esses componentes.
              </p>
              <p style={{color: '#ffffff' }}>
                O primeiro passo é posicionar corretamente as peças hidrossanitárias, como ralos, pias e vasos sanitários, respeitando sempre os níveis e referências do projeto. Em seguida, será necessário criar e configurar os diferentes tipos de tubulação, por exemplo, distinguindo a rede de água fria da rede de água quente.
              </p>
              <p style={{color: '#ffffff' }}>
                Até aqui trabalhamos cada elemento de forma separada. A partir de agora, vamos conectá-los para montar uma rede completa, que represente com clareza e fidelidade como será a execução na obra.
              </p>
            </div>
        
          </div>
        </article>
                       

        {/* ---------------------------- TELA 26 --------------------------------------- */}
        <article className="post comeco1-p2-t" style={{ 
          display: 'flex', 
          alignItems: 'center'
        // background: '#ffffff' 
        }}>
        <div className="container" style={{paddingBottom: '30px'}}>
          <div className="row" style={{ marginLeft: 0, marginTop: '10px', color: '#ffffff', display: 'block' }}>
            <p className="fontS-18" style={{width: '100%'}}>
              <strong>Alocação de peças hidrossanitárias</strong>
            </p>
            <p className="fontS-18" style={{width: '100%'}}>
              Para que o sistema hidrossanitário funcione corretamente, é fundamental <strong>posicionar as peças de forma adequada</strong>, como chuveiros, pias, ralos e vasos sanitários.
            </p>
            <p className="fontS-18" style={{width: '100%'}}>
              No Revit, esse processo depende principalmente de dois pontos essenciais:
            </p>          
          </div>
          <div className="row fontS-18" style={{ marginTop: '40px', marginBottom: '30px' }}>
            <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  background: 'linear-gradient(to bottom, #e6e6e600 55%, #006191 0%)',
                  width: '100%',
                  height: '220px',
                  paddingTop: '2%',
                  borderRadius: '12px',
                  border: '2px solid #1c7fa0 '
                }}
              >
                <p className='width95'
                  style={{
                    backgroundColor: '#629fb9',
                    color: '#ffffff',
                    fontWeight: 400,
                    padding: '5%',
                    width: '95%',
                    height: '87%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <ul>
                    <li>Faixa de vista: garante que o elemento seja visível na planta, evitando problemas de visualização.</li>
                    <li>Elevação padrão: define a altura correta de inserção da peça, de acordo com o projeto.</li>
                  </ul>
                </p>
              </div>
            </div>
          </div> 

          <div className="row" style={{ marginLeft: 0, marginTop: '10px', color: '#ffffff', display: 'block' }}>
            <p className="fontS-18" style={{width: '100%'}}>
              Com esses ajustes os componentes podem ser posicionados corretamente, respeitando as normas e tornando a modelagem mais fiel à execução real da obra.
            </p>
          </div>   
        </div>
      </article>                  


        {/* ---------------------------- TELA 27 --------------------------------------- */}
        <article
          className="post comeco1"
          style={{
            alignItems: 'normal',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#EDE6D8',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <p>
                  Em alguns casos, ao inserir um elemento no projeto, ele pode não ficar visível imediatamente. Não se preocupe: isso é comum e pode ser resolvido com algumas verificações simples.
                </p>
              </div>            
            </div>

            <div className="row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className="col-md-6 fontS-18">
                <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', color: '#ffffff' }}>
                   <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px' }}>
                    <img src="./img/module2/modulo2_pag27.png" style={{ width: '70%' }} alt="A imagem mostra um exemplo de uma instalação com tubo de esgoto em PVC." />
                  </div>
                </div>
              </div>

              <div className="col-md-6 fontS-18">
                <div style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                  <div style={{ borderLeft: '10px solid #D0E954', padding: '5%', backgroundColor: '#ffffff' }}>
                    <p><strong>1.	Verifique se o elemento está oculto: </strong>para isso, clique no ícone da lâmpada na barra de ferramentas inferior e confirme se o componente foi escondido por engano. </p>
                    <hr style={{ height: '1px', backgroundColor: '#479FC4' }} />
                    <p><strong>2.	Ajuste a faixa de vista: </strong>caso não esteja oculto, confira se o elemento está dentro do campo de visualização definido para a planta. Ajustar a faixa de vista geralmente resolve esse problema.</p>
                  </div>
                </div>
              </div>
            </div>

             <div className="row">
              <div className="col-md-12">
                <p>
                  Seguindo esses passos, você conseguirá corrigir a maioria das situações em que um elemento não aparece na tela.
                </p>
              </div>            
            </div>
          </div>
        </article>

        {/* ---------------------------- TELA 28 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '60px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Confira no vídeo a demonstração prática de como realizar a alocação de peças nas conexões hidráulicas.
                </p>                          
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/YtNQWWhWF60?si=yHU0IQpOn7TqadH2" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Lembre-se que alocar corretamente as peças é o que garante a ligação entre os componentes e prepara o terreno para o lançamento das tubulações.
                </p>                          
              </div>
            </div>

        
          </div>
        </article>

        {/* ---------------------------- TELA 29 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ 
          // backgroundColor: "#131326", 
          display: 'flex', 
          alignItems: 'center'
          }}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">          
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                <strong>Criação e configuração dos tipos de tubulação</strong>
              </p>
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                Para especificar os <strong>tipos de tubulação</strong> em um sistema hidrossanitário, é preciso considerar a <strong>finalidade da água</strong> (quente, fria, esgoto ou pluvial) e as normas técnicas aplicáveis. No caso das <strong>tubulações de água quente</strong>, alguns aspectos exigem atenção especial:
              </p>            
            </div>

            {[1, 2, 3, 4].map((item, index) => {
              const isOpen = openIndex4 === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion4(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Diâmetro da Tubulação</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Material da Tubulação</strong>}                        
                          {index === 2 && <strong>Isolamento Térmico</strong>}                        
                          {index === 3 && <strong>Conexões e Acessórios</strong>}                        
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O diâmetro deve ser configurado de acordo com as necessidades do projeto. Ele é crítico para determinar a vazão de água quente necessária ao atendimento das demandas do sistema. 
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O material precisa suportar as temperaturas elevadas da água quente. É necessário selecionar materiais adequados, como cobre, CPVC, PPR ou PEX, que apresentem boas propriedades térmicas e resistência.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Em tubulações metálicas, é comum aplicar isolamento térmico para conservar a temperatura da água e evitar perdas de calor. Esse aspecto também é importante no modelo BIM, pois influencia no cálculo energético e na eficiência do sistema.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Devem ser escolhidos elementos capazes de suportar temperaturas elevadas e pressões compatíveis. Inclui válvulas, registros e outros componentes que entram em contato direto com a água quente.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                    </div>
                  )}
                </div>
              );
            })}

          </div>
        </article>

  


        {/* ---------------------------- TELA 30 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ 
          backgroundColor: "#ffffff", 
          display: 'flex',
          alignItems: 'center'
          }}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">          
              <p className="fontS-18" style={{ color: "#000000", marginBottom: '60px' }}>
                Assim como na água quente, a definição e configuração das tubulações de água fria devem seguir normas técnicas (principalmente ABNT NBR 5626) e considerar o desempenho e a durabilidade do sistema.
              </p>             
            </div>

            {[1, 2, 3, 4].map((item, index) => {
              const isOpen = openIndex5 === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion5(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Diâmetro da Tubulação</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Material da Tubulação</strong>}                        
                          {index === 2 && <strong>Isolamento Térmico</strong>}                        
                          {index === 3 && <strong>Conexões e Acessórios Específicos</strong>}                        
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              O diâmetro da tubulação para água fria deve ser escolhido com base nas demandas de vazão e pressão do sistema. Devemos configurar diâmetros apropriados para garantir o desempenho adequado do sistema; 
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Para água fria, é comum usar materiais como PVC soldável, PVC rosqueável ou PEX, que são adequados para a condução de água em temperaturas ambiente. O Revit permite selecionar o material correto e suas propriedades para o cálculo de pressão e vazão;
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Em algumas situações, pode ser necessário adicionar isolamento térmico à tubulação de água fria, especialmente em locais onde a condensação pode ser um problema;
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              É importante escolher conexões e acessórios apropriados para sistemas de água fria, considerando a compatibilidade com o material da tubulação e as necessidades do projeto.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                    </div>
                  )}
                </div>
              );
            })}
        

          </div>
        </article>

        
        {/* ---------------------------- TELA 31 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '60px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  A criação das tubulações no Revit segue uma lógica simples. Acompanhe a seguir, com o especialista:
                </p>                          
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/PmZbaIXKiGs?si=4SWvgiYqPWuMXBej" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 32 --------------------------------------- */}
        <article className="post comeco1-p2-t" style={{ 
          display: 'flex', 
          alignItems: 'center',
        background: '#EDE6D8' 
        }}>
        <div className="container" style={{paddingBottom: '30px'}}>
          <div className="row" style={{ marginLeft: 0, marginTop: '10px', color: '#000000', display: 'block' }}>
            <p className="fontS-18" style={{width: '100%'}}>
              Note que a modelagem dos sistemas de água fria e de água quente no Revit utiliza as mesmas ferramentas, 
              diferenciando-se apenas pelas <strong>famílias específicas</strong> aplicadas em cada disciplina, pelos 
              <strong> componentes escolhidos</strong> e pelos <strong>metadados</strong> associados a cada elemento, que garantem a correta identificação e 
              distinção entre os sistemas.
            </p>              
          </div>
          <div className="row fontS-18" style={{ marginTop: '40px', marginBottom: '30px' }}>
            <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  background: 'linear-gradient(to bottom, #e6e6e600 55%, #006191 0%)',
                  width: '100%',
                  height: '320px',
                  paddingTop: '2%',
                  borderRadius: '12px',
                  border: '2px solid #1c7fa0 '
                }}
              >
                <p className='width95'
                  style={{
                    backgroundColor: '#629fb9',
                    color: '#ffffff',
                    fontWeight: 400,
                    padding: '5%',
                    width: '95%',
                    height: '87%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderRadius: '12px',
                    // display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  Além do uso do software, é fundamental que os sistemas hidrossanitários respeitem as <strong>normas técnicas (NBRs)</strong> aplicáveis:
                  <ul style={{marginTop: '15px'}}>
                    <li><strong>ABNT NBR 5626:2020</strong> → Instalações prediais de água fria e água quente.</li>
                    <li><strong>ABNT NBR 8160:1999</strong> → Sistemas de esgoto sanitário.</li>
                    <li><strong>ABNT NBR 10844:1989</strong> → Sistemas de águas pluviais</li>
                  </ul>
                </p>
              </div>
            </div>
          </div> 

          <div className="row" style={{ marginLeft: 0, marginTop: '10px', color: '#000000', display: 'block' }}>
            <p className="fontS-18" style={{width: '100%'}}>
              Muitos fabricantes já disponibilizam componentes paramétricos com as informações técnicas incorporadas. Porém, cabe ao projetista verificar e validar esses dados para garantir que o modelo atenda tanto às exigências normativas quanto às condições reais de projeto.
            </p>
          </div>   
        </div>
      </article>                  


        {/*---------------------------- TELA QUESTÔES ---------------------------------- --> */}
        
        <article
          className="post avanco7-M2-t"
          style={
            {
              // display: "none",
              // backgroundColor: "#304F64"
            }
          }
        >
          <div className="container">
            {/* ENCERRAMENTO DO MÓDULO */}
            <div
              style={{
                backgroundColor: "#EDE6D8",
                padding: "60px 20px",
                borderRadius: "12px",
                textAlign: "center",
                marginTop: "60px",
                marginBottom: "60px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h2
                style={{
                  color: "#131326",
                  fontSize: "32px",
                  fontWeight: "700",
                  marginBottom: "25px",
                }}
              >
                🛠️ Vamos exercitar?
              </h2>

              <p
                style={{
                  color: "#131326",
                  fontSize: "18px",
                  lineHeight: "1.6",
                  maxWidth: "800px",
                  margin: "0 auto 30px auto",
                  textAlign: "justify",
                }}
              >
                Vamos praticar o que aprendemos! Com o template pronto, já temos a base configurada. Agora, no Revit, vamos modelar a rede de água fria e elaborar a planta, compreendendo como cada parte do sistema se organiza. 
              </p>

              <div style={{ marginTop: "30px" }}>
                <p
                  style={{
                    color: "#131326",
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  📥 Baixe o roteiro do Exercitando  e siga o passo a passo.
                </p>

                <div className="row">
                  
                </div>

                <a
                  onClick={() => {
                  const link = document.createElement('a');
                  link.href = './downloads/exercitando2.docx';
                  link.download = 'Exercitando2.docx';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                  style={{
                    display: "inline-block",
                    backgroundColor: "#131326",
                    color: "#EDE6D8",
                    padding: "12px 30px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    marginRight: '15px'
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0c59a1ff", e.currentTarget.style.cursor = 'pointer')
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#131326")
                  }
                >
                  ⬇️ Download do Roteiro Exercitando 2
                </a>


                <a
                  onClick={() => {
                  const link = document.createElement('a');
                  link.href = './downloads/FamiliasHidrossanitario_Exercitando01.rar';
                  link.download = 'FamiliasHidrossanitario.rar';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                  style={{
                    display: "inline-block",
                    backgroundColor: "#131326",
                    color: "#EDE6D8",
                    padding: "12px 30px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0c59a1ff", e.currentTarget.style.cursor = 'pointer')
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#131326")
                  }
                >
                  ⬇️ Download do Template Hidrossanitário Exercitando 2
                </a>
              </div>
            </div>
          </div>
        </article>


        {/* ---------------------------- TELA 33 --------------------------------------- */}

        <article 
          className="post avanco6-M2-p2-1f" 
          style={{ 
            display: "flex",  
            minHeight: "100vh", 
            // backgroundImage: "url(./img/modulos/modulo2/parte2/bg_modulo2_parte2_pag31.png)", 
            // backgroundRepeat: "no-repeat", 
            // backgroundSize: "cover" 
          }}
        >
          <div 
            className="container" 
            style={{ 
              display: "flex", 
              justifyContent: "center", 
              width: "80%" 
            }}
          >
            <div 
              className="row" 
              style={{ 
                justifyContent: "center", 
                alignItems: "center", 
                marginBottom: "60px" 
              }}
            >
              <div 
                className="col-md-8 fontS-18"
                style={{ 
                  padding: "5% 7%", 
                  minHeight: "400px", 
                  background: "linear-gradient(133deg, rgb(255 255 255 / 94%) 15%, rgb(215 215 215 / 94%) 75%)", 
                  borderRadius: "12px" 
                }}
              >  
                <p>
                  Chegamos ao final do segundo módulo do curso. Nessa jornada, concluímos a configuração das tubulações de água fria e quente no Revit, definindo materiais, conexões e parâmetros essenciais para garantir desempenho, durabilidade e conformidade com as normas técnicas. 
                </p>
                <p>                  
                  A partir daqui, avançaremos para novos desafios da modelagem hidrossanitária: criação de sistemas de esgoto, aplicação de filtros e modelos de vista para organização, além do uso de editores de sistema, ajustes de rotas e técnicas de isolamento de tubulações.
                </p>
                <p>
                  Na sequência, você também aprenderá a documentar o projeto de forma completa e a preparar a entrega profissional, tornando o modelo BIM não apenas uma representação técnica, mas um instrumento de comunicação, análise e geração de valor em todas as etapas do ciclo de projeto.
                </p>
                <p>
                  <strong>Bons estudos!</strong>
                </p>
              </div>
            </div>
          </div>
        </article>







      </section>
    </>
  );
};

export default Lesson2;